import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class GlobalSearchComponent extends BaseComponent {
  @Input() showSearch = false;
  @Output() onHideSearch: EventEmitter<unknown> = new EventEmitter();
}
